module.exports = __webpack_public_path__ + "static/media/lightbulb.440d5173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/lightbulb.png
// module id = 1529
// module chunks = 51